export default {"src":"/_next/static/media/avanti-logo-white-xl.7581accc.svg","height":42,"width":127,"blurWidth":0,"blurHeight":0};